<template>
  <div style="margin-top: 30px">
    <h5 class="add_bottom_15">
      {{ $t('lang.stores.services') }}
    </h5>

    <div class="col-lg-12 add_bottom_30">
      <div>
        <ul class="links pt-0 two-columns bullets">
          <li v-if="hasWifiService">
            <i class="icon-wifi" />{{ $t('lang.services.wifi') }}
          </li>
          <li v-if="hasOutletService">
            <i class="fas fa-plug" />{{ $t('lang.services.outlet') }}
          </li>
          <li v-if="hasWCService">
            <i class="fas fa-restroom" />{{ $t('lang.services.wc') }}
          </li>
          <li v-if="hasAccessibleService">
            <i class="fas fa-wheelchair" />{{ $t('lang.services.accessible') }}
          </li>
          <li v-if="!store.is_locker">
            <i class="icon-tag-1" />{{ $t('lang.services.seal') }}
          </li>
          <li>
            <i class="fas fa-shield-alt" />{{ $t('lang.services.protection') }}
            <a
              href="/terms-and-conditions#insurance"
              target="_blank"
            >(+ info)</a>
          </li>
          <li><i class="fas fa-times" />{{ $t('lang.services.cancellation') }}</li>
          <li><i class="fas fa-comments" />{{ $t('lang.services.support') }}</li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'StoreServices',

  props: {
    store: {
      type: Object,
      required: true,
    },
  },

  computed: {
    hasWifiService() {
      let hasService = false;
      if (this.store) {
        this.store.store_services.forEach((storeService) => {
          if (storeService.service_id === 'wifi') hasService = true;
        });
      }

      return hasService;
    },

    hasWCService() {
      let hasService = false;
      if (this.store) {
        this.store.store_services.forEach((storeService) => {
          if (storeService.service_id === 'wc') hasService = true;
        });
      }

      return hasService;
    },

    hasOutletService() {
      let hasService = false;
      if (this.store) {
        this.store.store_services.forEach((storeService) => {
          if (storeService.service_id === 'outlet') hasService = true;
        });
      }

      return hasService;
    },

    hasAccessibleService() {
      let hasService = false;
      if (this.store) {
        this.store.store_services.forEach((storeService) => {
          if (storeService.service_id === 'wheelchair_accessible') hasService = true;
        });
      }

      return hasService;
    },
  },
};
</script>
